import { RexDateTime } from "../Dates/RexDateTime";
import { TServiceResult } from "./TServiceResult";

export class VentLog
{
    SmokeID: string = "";
    Timestamp: RexDateTime | Date = new RexDateTime(0);
    Vent1: number = 0;
    Vent2: number = 0;
    Vent3: number = 0;
    Comment: string = "";
}

export type ServiceVentLogs = TServiceResult<VentLog[]>;

export const EmptyServiceVentLogs: ServiceVentLogs =
{
    TheValue: [],
    Result: false,
    Reason: "Not initialized",
    CorrelationID: "",
    Succeeded: false
}

export function ventTime(v: VentLog): string
{
    return (v.Timestamp as RexDateTime).toLocalTimeString();
}